import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "modal-bg" }
const _hoisted_2 = { class: "modal modal--prompt" }
const _hoisted_3 = { class: "modal-title" }
const _hoisted_4 = { class: "modal-text text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h4", _hoisted_3, _toDisplayString($props.mainTitle), 1),
      _createElementVNode("p", _hoisted_4, _toDisplayString($props.subTitle), 1),
      _createVNode($setup["ButtonComponent"], {
        class: _normalizeClass($props.yesButtonColorClass),
        block: "",
        onClick: $setup.onConfirm
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString($props.yesTitle), 1)
        ]),
        _: 1
      }, 8, ["class"]),
      _createElementVNode("a", {
        class: "modal-continue",
        href: "#",
        onClick: _withModifiers($setup.onCancel, ["prevent"])
      }, _toDisplayString($props.noTitle), 1)
    ])
  ]))
}